import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="w-full py-24 px-6 bg-[#111111]" data-id="element-76">
      <div className="max-w-3xl w-full mx-auto space-y-12" data-id="element-77">
        {/* Label */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-78">
          <span className="text-[#D4A853] text-xs md:text-sm tracking-[0.2em] uppercase font-medium" data-id="element-79">
            LA REVELACIÓN
          </span>
        </motion.div>

        {/* Content */}
        <div className="space-y-8" data-id="element-80">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="text-3xl md:text-5xl font-serif text-[#F5F0E8] leading-tight" data-id="element-81">
            El problema no es tu falta de voluntad.
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="space-y-6 text-lg md:text-xl leading-relaxed text-[#A89F91]" data-id="element-82">
            <p data-id="element-83">
              El problema no es tu falta de voluntad, ni que necesites más café.
              El problema es que tu sistema nervioso se bloqueó en{' '}
              <span className="text-[#D4A853] font-serif italic" data-id="element-84">
                Modo Supervivencia
              </span>
              .
            </p>

            <p data-id="element-85">
              Has pasado tanto tiempo cuidando a los demás y cumpliendo
              responsabilidades que tu mente activó el{' '}
              <span className="text-[#D4A853] font-serif italic" data-id="element-86">
                Piloto Automático
              </span>{' '}
              para no colapsar. Pero ese modo automático te ha robado la
              capacidad de disfrutar, de decidir y de sentir vitalidad.
            </p>

            <div className="pl-6 border-l-2 border-[#D4A853]/30 py-2 my-8" data-id="element-87">
              <p className="text-[#F5F0E8] italic text-2xl font-serif" data-id="element-88">
                Las vacaciones no lo arreglan. La motivación barata no sirve.
                Necesitas un{' '}
                <span className="text-[#D4A853] font-bold not-italic" data-id="element-89">
                  Reinicio Operativo
                </span>
                .
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}